import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import {
  AboutUs,
  Contact,
  HomePage,
  LandingPage,
  LoginPage,
  SolutionsPage,
  RegisterClient,
} from "./screens";
import { ReportsPage } from "./screens/Report";
import { UserProvider } from "./context/UserContext";

function App() {
  return (
    <UserProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" exact element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/report" element={<ReportsPage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/clients/create" element={<RegisterClient />} />
        </Routes>
      </BrowserRouter>
    </UserProvider>
  );
}

export default App;
